import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { MaterialMappingSpec, OperationSegmentSpec } from '../../../process-plan'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { IOperationSegmentDialogOptions } from '../../operation-segment-spec-detail-dialog/operation-segment-spec-detail-dialog.component'
import { OperationMaterialMappingDetailComponent } from '../operation-material-mapping-detail/operation-material-mapping-detail.component'

export interface IOperationMaterialMappingDialogOptions {
  readonly operation: OperationSegmentSpec
}

@Component({
  selector: 'app-operation-material-mapping-detail-dialog',
  templateUrl: './operation-material-mapping-detail-dialog.component.html',
  styleUrls: ['./operation-material-mapping-detail-dialog.component.scss'],
  imports: [OperationMaterialMappingDetailComponent],
})
export class OperationMaterialMappingDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly original: OperationSegmentSpec
  public readonly copy: OperationSegmentSpec
  private dialogRef =
    inject<MatDialogRef<OperationMaterialMappingDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IOperationSegmentDialogOptions>(MAT_DIALOG_DATA)
    this.copy = new OperationSegmentSpec()
    this.original = data.operation
    this.update(this.copy, this.original)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.update(this.original, this.copy)
    this.close(this.original)
  }

  public close(operation?: OperationSegmentSpec): void {
    this.dialogRef.close(operation)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private update(target: OperationSegmentSpec, source: OperationSegmentSpec): void {
    if (source?.action) {
      target.action = source.action
    }
    if (source?.materialMappingSpec) {
      const spec = source.materialMappingSpec
      target.materialMappingSpec = new MaterialMappingSpec(
        spec.consumptionMaterialPaths
          ? [...source.materialMappingSpec.consumptionMaterialPaths]
          : [],
        spec.finishedMaterialPaths ? [...source.materialMappingSpec.finishedMaterialPaths] : [],
        source.materialMappingSpec.retainBomNames // Feature flag
      )
    }
  }
}
